<div>
  <br/>

  <div class="cursor-pointer my-1 link-primary" data-bs-toggle="modal"
       data-bs-target="#createAlarm">Create new alarm
  </div>

  <br/>
  <br/>

  <div class="block">
    <table class="tbl">
      <thead>
      <tr>
        <th>Code</th>
        <th>Type</th>
        <th>Description</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let alarm of alarmService.list(limit, offset)">
        <td>{{ alarm.code }}</td>
        <td>{{ 'app.' + alarmTypeService.get(alarm.type).thymeleaf | translate }}</td>
        <td>
          <div *ngFor="let locale of alarm.locales">
            <p>{{ locale.title }}</p>
            <p>{{ locale.text }}</p>
          </div>
        </td>
        <td>
          <button type="button" class="btn btn-sm btn-primary"
                  (click)="editAlarm(alarm.id)" translate>app.buttons.edit
          </button>
          <button type="button" class="btn btn-sm btn-danger"
                  (click)="removeAlarm(alarm.id)"
                  *ngIf="!alarmTypeService.get(alarm.type).system" translate>app.buttons.remove
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="modal fade modal-lg" id="createAlarm" data-bs-backdrop="static"
       data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Create new alarm</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 mb-4" [innerHTML]="'app.alarm.description' | translate"></div>
            <div class="col-12 mb-3">
              <div class="form-floating">
                <input type="text" id="alarm_code" autocomplete="off"
                       class="form-control form-control-sm"
                       [disabled]="alarm.id !== ''"
                       [(ngModel)]="alarm.code"
                       placeholder="{{'app.alarm.code.example' | translate}}"/>
                <label for="alarm_code" translate>app.alarm.code</label>
              </div>
            </div>
            <div class="col-12 mb-3">
              <div class="form-floating">
                <select id="alarm_type"
                        class="form-control form-control-sm"
                        [(ngModel)]="alarm.type">
                  <option *ngFor="let type of alarmTypeService.getTypes()"
                          [value]="type.id" [hidden]="type.system">{{ 'app.' + type.thymeleaf | translate }}
                  </option>
                </select>
                <label translate>app.alarm.alarm-type</label>
              </div>
            </div>
            <div class="col-12">
              <label class="form-label" for="alarm_properties" translate>app.alarm.properties</label>
              <div class="input-group input-group-sm mb-3">
                <select id="alarm_properties" class="form-control form-control-sm"
                        [(ngModel)]="alarmAttrTypeId">
                  <option *ngFor="let alarmAttrType of alarmAttributeTypeService.getTypes()"
                          [value]="alarmAttrType.id"
                          [hidden]="alarmAttrType.system">{{ 'app.' + alarmAttrType.thymeleaf | translate }}
                  </option>
                </select>
                <button class="btn btn-sm" type="button" (click)="addAttr()" translate>app.buttons.add</button>
              </div>
              <div class="row">
                <div class="col-12 mb-3" *ngFor="let attr of alarm.attrs">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">
                      {{ 'app.' + alarmAttributeTypeService.get(attr.type).thymeleaf | translate }}
                    </span>
                    <input type="text" autocomplete="off"
                           class="form-control form-control-sm"
                           [(ngModel)]="attr.value"/>
                    <button class="btn btn-sm btn-danger" type="button" *ngIf="attr.id" translate>app.buttons.remove
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="offset-lg-2 col-12 mb-3">
              <button *ngFor="let language of languageService.getLanguages()"
                      [ngClass]="{ 'active' : this.langId == language.id}"
                      (click)="this.langId = language.id; renderer()"
                      class="btn btn-sm"
                      type="button">
                {{ 'app.' + language.name | translate }}
              </button>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-2">
                  <div class="btn-group-vertical">
                    <button *ngFor="let level of alarmLevelService.getLevels()"
                            [ngClass]="{ 'active' : this.levelId == level.id}"
                            [hidden]="level.system"
                            (click)="this.levelId = level.id; renderer()"
                            class="btn btn-sm"
                            type="button">
                      {{ 'app.' + level.name | translate }}
                    </button>
                  </div>
                </div>
                <div class="col-10">
                  <div class="row">
                    <div class="col-12 mb-3">
                      <div class="form-floating">
                        <input type="text" id="alarm_title" autocomplete="off"
                               class="form-control form-control-sm"
                               [(ngModel)]="alarm.locales[levelId + ':' + langId].title"
                               placeholder="{{'app.alarm.title.example' | translate}}"/>
                        <label for="alarm_title" translate>app.alarm.title</label>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-floating">
                        <textarea id="alarm_text" rows="5"
                                  class="form-control form-control-sm"
                                  [(ngModel)]="alarm.locales[levelId + ':' + langId].text"
                                  placeholder="{{'app.alarm.text' | translate}}"></textarea>
                        <label for="alarm_text" translate>app.alarm.text</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12" *ngIf="alarm.error">{{ alarm.error }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary"
                  data-bs-dismiss="modal" translate>app.buttons.cancel
          </button>
          <button type="button" class="btn btn-sm btn-primary"
                  (click)="alarmService.create($event, alarm)" translate>app.buttons.create
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
